'use client';

import useSWR from 'swr';
import { API_URLS, SWR_REQUEST_DEFAULTS } from '@/lib/api/config';
import { TypeCoursesResponseData } from '@/lib/api/playbackService/types';

export default function useUserCourses(shouldFetch = true) {
  const uri = `${API_URLS.PLAYBACK_SERVICE_PROXY}/user_courses`;

  const { data, error, mutate, isLoading } = useSWR<
    TypeCoursesResponseData,
    Error
  >(shouldFetch ? uri : null, SWR_REQUEST_DEFAULTS);

  return {
    data,
    loading: isLoading,
    error,
    mutate,
  };
}
